import { hasSubscriptionFlag as getFeatureFlag } from '@/data/flags/local-flags';

export function setAnalyticsTagForButton (button, bannerType) {
    button.analyticsTag = {
        type: `global-banner:${bannerType}`,
        value: button.label,
    };

    return button;
}

export function canHaveGlobalBanner (params) {
    const { isTopBannerDismissed, currentRoute } = params;
    if (isTopBannerDismissed === true || ['BuyNow', 'TrialExpired'].includes(currentRoute)) {
        return false;
    }

    return true;
}

export function activePlan () {
    const isPendoFree = getFeatureFlag('pendoFree');
    const isStarterPackage = getFeatureFlag('starterPackage');
    const isStarter2024Package = getFeatureFlag('starter2024Package');

    if (isPendoFree) {
        return 'pendoFree';
    }
    if (isStarterPackage) {
        return 'starterPackage';
    }
    if (isStarter2024Package) {
        return 'starter2024Package';
    }

    return '';
}
